import type { CreateStaffRequest } from '@/definitions/staff'

import type { CreateOrgFormValues } from '../definitions/createOrganizationForm'

/**
 * Maps the collected form values to the staff create request.
 *
 * The four identity fields and the temporary password are required. Blank
 * optionals are omitted rather than sent: the columns read "not filled in" as
 * null, and an empty string would store as a value the practice then has to
 * clear.
 *
 * `primaryLocationId` is the organization's primary location — created in this flow
 * or already on record — and is not a choice the form offers; null assigns nothing.
 */
export const buildStaffRequest = (
  values: CreateOrgFormValues,
  primaryLocationId: string | null
): CreateStaffRequest => {
  const npi = values.admin_npi.trim()
  const licenseNumber = values.admin_license_number.trim()

  return {
    name_given: values.admin_name_given.trim(),
    name_family: values.admin_name_family.trim(),
    username: values.admin_username.trim(),
    email: values.admin_email.trim(),
    // Not trimmed: leading or trailing spaces are legitimate password characters,
    // and silently dropping them would hand over a password that does not work.
    temporary_password: values.admin_temporary_password,
    ...(npi && { npi }),
    ...(licenseNumber && { license_number: licenseNumber }),
    ...(primaryLocationId && { primary_location_id: primaryLocationId }),
  }
}
